define('CMS.Fix', [
    'CMSadapter.Impl.Categories.v3.Navigation.Fix'
], function CartFix(
) {
    'use strict';

    return {};
});

